import React, { useEffect, useState } from 'react';

export default function Overview({ role }) {
  const [stats, setStats] = useState({ contacts: 0, appointments: 0, users: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        setLoading(true);
        const [contactsRes, apptsRes, usersRes] = await Promise.all([
          fetch('/api/get_contacts.php', { credentials: 'include' }),
          fetch('/api/get_appointments.php', { credentials: 'include' }),
          role === 'admin' ? fetch('/api/get_users.php', { credentials: 'include' }) : Promise.resolve(null),
        ]);
        const contacts = contactsRes ? await contactsRes.json() : { contacts: [] };
        const appts = apptsRes ? await apptsRes.json() : { appointments: [] };
        const users = usersRes ? await usersRes.json() : { data: [] };
        if (!cancelled) {
          setStats({
            contacts: contacts?.contacts?.length || 0,
            appointments: appts?.appointments?.length || 0,
            users: role === 'admin' ? (users?.data?.length || 0) : 0,
          });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [role]);

  return (
    <section className="space-y-6">
      <h1 className="text-2xl font-semibold">Overview</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <KpiCard label="Contacts" value={stats.contacts} loading={loading} />
        <KpiCard label="Appointments" value={stats.appointments} loading={loading} />
        {role === 'admin' && <KpiCard label="Users" value={stats.users} loading={loading} />}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <PlaceholderCard title="Monthly Activity Chart" />
        <PlaceholderCard title="Appointment Status Distribution" />
      </div>
    </section>
  );
}

function KpiCard({ label, value, loading }) {
  return (
    <div className="rounded-lg border bg-white p-4">
      <div className="text-sm text-gray-500">{label}</div>
      <div className="mt-2 text-3xl font-semibold">{loading ? '…' : value}</div>
    </div>
  );
}

function PlaceholderCard({ title }) {
  return (
    <div className="rounded-lg border bg-white p-4 h-64 grid place-items-center text-gray-400">
      {title} (to be implemented)
    </div>
  );
}
